<template>
    <div class="content">
        <div class="row">
            <div class="col-md-10 flex-container-top">
                <h2 class="text-eveer">Event Schedule List</h2>
                <base-button v-if="role == 'Admin'" type="primary" round icon class="top-button"
                    @click="$router.push('add?id=-1')">
                    <i class="fa fa-plus"></i>
                </base-button>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <card>
                    <form onSubmit="return false;">
                        <div class="row">
                            <div class="col-md-6">
                                <base-input type="text" label="Column 1 *" maxlength="50" placeholder="Column 1"
                                    v-model="column1">
                                </base-input>
                            </div>
                            <div class="col-md-6">
                                <base-input type="text" label="Column 2 *" maxlength="50" placeholder="Column 2"
                                    v-model="column2">
                                </base-input>
                            </div>
                        </div>

                        <div class="row mt-4">
                            <div class="col-md-6">
                                <base-input type="text" label="Column 3 *" maxlength="50" placeholder="Column 3"
                                    v-model="column3">
                                </base-input>
                            </div>
                            <div class="col-md-6">
                                <label>Column 4 *</label>
                                <input class="location form-control" id="auto-complete-text" v-model="column4"
                                    placeholder="Column 4" @keydown.enter.prevent />
                            </div>
                        </div>

                        <base-button native-type="submit" type="primary" @click="UpdateScheduleKey()" class="btn-fill"
                            :disabled="loading">Update
                        </base-button>

                    </form>
                </card>
            </div>
        </div>
        <div class="row mt-5" v-if="this.tableData.length !== 0">
            <div class="col-12">
                <card card-body-classes="table-full-width">
                    <h4 slot="header" class="card-title">Event Schedule List</h4>
                    <div>
                        <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
                            <el-select class="select-primary mb-3 pagination-select" v-model="pagination.perPage"
                                placeholder="Per page">
                                <el-option class="select-primary" v-for="item in pagination.perPageOptions" :key="item"
                                    :label="item" :value="item">
                                </el-option>
                            </el-select>
                            <base-input>
                                <el-input type="search" class="mb-3 search-input" clearable prefix-icon="el-icon-search"
                                    placeholder="Search records" v-model="searchQuery" aria-controls="datatables">
                                </el-input>
                            </base-input>
                        </div>
                        <el-table :data="queriedData" style="font-size: 13px">
                            <el-table-column :min-width="150" align="left" :label="column1">
                                <div slot-scope="props">
                                    <div style="font-weight: 300;">
                                        {{ props.row.value1 }}
                                    </div>
                                </div>
                            </el-table-column>
                            <el-table-column :min-width="200" align="left" :label="column2">
                                <div slot-scope="props">
                                    <div style="font-weight: 300;">
                                        {{ props.row.value2 }}
                                    </div>
                                </div>
                            </el-table-column>
                            <el-table-column :min-width="200" align="left" :label="column3">
                                <div slot-scope="props">
                                    <div>{{ props.row.value3 }}</div>
                                </div>
                            </el-table-column>
                            <el-table-column :min-width="200" align="left" :label="column4">
                                <div slot-scope="props">
                                    <div>{{ props.row.value4 }}</div>
                                </div>
                            </el-table-column>
                            <el-table-column :min-width="200" align="left" label="Control">
                                <div slot-scope="props">
                                    <i v-if="role == 'Admin'" class="fa fa-edit text-warning icon-padding"
                                        @click="$router.push('edit?id=' + props.row._id)" title="Edit Schedule"
                                        style="cursor: pointer"> </i>
                                    <i v-if="role == 'Admin'" class="fa fa-trash-alt text-danger icon-padding"
                                        @click="deleteSchedule(props.row._id)" title="Delete Schedule"
                                        style="cursor: pointer">
                                    </i>
                                </div>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div slot="footer"
                        class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
                        <div class="">
                            <p class="card-category">
                                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
                            </p>
                        </div>
                        <base-pagination class="pagination-no-border" v-model="pagination.currentPage"
                            :per-page="pagination.perPage" :total="total">
                        </base-pagination>
                    </div>
                </card>
            </div>
        </div>

        <div class="row loader-pos">
            <div class="sk-chase" v-if="loading">
                <div class="sk-chase-dot"></div>
                <div class="sk-chase-dot"></div>
                <div class="sk-chase-dot"></div>
                <div class="sk-chase-dot"></div>
                <div class="sk-chase-dot"></div>
                <div class="sk-chase-dot"></div>
            </div>

            <div class="no-data-message" v-if="noDataMessage">
                <div>There are no records found</div>
            </div>
        </div>


        <div>
            <!-- <b-button id="show-btn" @click="$bvModal.show('bv-modal-example')">Open Modal</b-button> -->
            <b-modal id="popUpAssignModal" hide-footer>
                <template #modal-title>
                    Using <code>$bvModal</code> Methods
                </template>
                <div class="d-block text-center">
                    <h3>Hello From This Modal!</h3>
                </div>
                <b-button class="mt-3" block @click="$bvModal.hide('bv-modal-example')">Close Me</b-button>
            </b-modal>
        </div>
        <!-- Classic Modal -->
    </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import { BasePagination } from "src/components";
import Fuse from "fuse.js";
import swal from "sweetalert2";
import { Modal, BaseAlert } from "src/components";

export default {
    components: {
        BasePagination,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        Modal,
        BaseAlert,
    },
    computed: {
        /***
         * Returns a page from the searched data or the whole data. Search is performed in the watch section below
         */
        queriedData() {
            let result = this.tableData;
            if (this.searchedData.length > 0) {
                result = this.searchedData;
            }
            return result.slice(this.from, this.to);
        },
        to() {
            let highBound = this.from + this.pagination.perPage;
            if (this.total < highBound) {
                highBound = this.total;
            }
            return highBound;
        },
        from() {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },
        total() {
            return this.searchedData.length > 0
                ? this.searchedData.length
                : this.tableData.length;
        },
    },
    data() {
        return {
            role: window.localStorage.getItem("role"),
            noDataMessage: false,
            loading: false,
            pagination: {
                perPage: 10,
                currentPage: 1,
                perPageOptions: [10, 50, 100, 1000],
                total: 0,
            },
            searchQuery: "",
            tableData: [],
            column1: "",
            column2: "",
            column3: "",
            column4: "",
            searchedData: [],
            fuseSearch: null,
        };
    },
    async mounted() {
        await this.loadSchedules();
    },
    watch: {
        /**
         * Searches through the table data by a given query.
         * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
         * @param value of the query
         */
        searchQuery(value) {
            let result = this.tableData;
            console.log(value);
            console.log(this.searchQuery);
            if (this.searchQuery !== "") {
                result = this.fuseSearch.search(this.searchQuery);
                console.log(result);
                result = result.map(a => a.item);
            }
            this.searchedData = result;
        },
    },
    methods: {
        async compare(a, b) {
            if (a > b) return +1;
            if (a < b) return -1;
            return 0;
        },

        async loadSchedules() {
            this.loading = true;
            let test = await this.$apiService.getCall("eventschedule/event-schedules");
            this.role = window.localStorage.getItem("role");
            var role = this.role;

            if (role == "Admin") {
                this.tableData = test.apidata.Data.AllEventSchedule || [];
                this.column1 = test.apidata.Data.ScheduleKey.column1 || "";
                this.column2 = test.apidata.Data.ScheduleKey.column2 || "";
                this.column3 = test.apidata.Data.ScheduleKey.column3 || "";
                this.column4 = test.apidata.Data.ScheduleKey.column4 || "";
            }

            this.fuseSearch = new Fuse(this.tableData, {
                keys: ["value1"],
                threshold: 0.3,
            });

            this.tableData.sort((a, b) => (this.compare(a.date, b.date) || this.compare(a.start_time, b.start_time)));
            this.loading = false;

            if ((this.tableData || []).length == 0) {
                this.noDataMessage = true;
            }
        },

        async deleteSchedule(id) {
            let confirmed = confirm("Are you sure you want to delete this Schedule? ");
            if (confirmed === true) {
                this.loading = true;
                const del_event = await this.$apiService.postCall("eventschedule/delete-event-schedule/" + id)
                console.log(del_event)
                if (del_event.apidata.Code !== "P00001") {
                    this.$apiService.notify(del_event.apidata.Message + ".");
                } else {
                    this.$apiService.notify("Schedule has been deleted.", { duration: 2000 });
                    await this.loadSchedules();
                }
                this.loading = false;
            }
        },

        async UpdateScheduleKey() {
            if (
                !this.column1 &&
                !this.column2 &&
                !this.column3 &&
                !this.column4
            ) {
                this.$apiService.notify("All column fields are mandatory.");
                return;
            }

            if (!this.column1 || this.column1.trim() === "") {
                this.$apiService.notify(`Column 1 is mandatory.`);
                return;
            }

            if (!this.column2 || this.column2.trim() === "") {
                this.$apiService.notify(`Column 2 is mandatory.`);
                return;
            }

            if (!this.column3 || this.column3.trim() === "") {
                this.$apiService.notify(`Column 3 is mandatory.`);
                return;
            }

            if (!this.column4 || this.column4.trim() === "") {
                this.$apiService.notify(`Column 4 is mandatory.`);
                return;
            }

            this.loading = true;
            const update_schedule_key = await this.$apiService.postCall("schedulekey/update-schedule-key", {
                column1: this.column1,
                column2: this.column2,
                column3: this.column3,
                column4: this.column4
            })
            console.log(update_schedule_key)
            if (update_schedule_key.apidata.Code !== "P00001") {
                this.$apiService.notify(update_schedule_key.apidata.Message + ".");
            } else {
                this.$apiService.notify("Column Name has been Updated.", { duration: 2000 });
                await this.loadSchedules();
            }
            this.loading = false;
        }
    },
};
</script>

<style>
.pagination-select,
.search-input {
    width: 200px;
}

.swal2-icon-content {
    font-size: inherit !important;
}

.group-img {
    width: 100%;
    max-width: 100px;
    height: 150px;
    border-radius: 50%;
    object-fit: cover;
}

.icon-padding {
    padding: 10px;
}
</style>